var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box wrapper-payroll-other-payments" },
    [
      _c("div", { staticClass: "title-container is-flex" }, [
        _c(
          "h4",
          {
            staticClass:
              "title is-centered is-4 has-text-primary title-payroll-other-payments"
          },
          [_vm._v("\n      Otros pagos\n    ")]
        ),
        _c(
          "div",
          { staticClass: "field is-centered" },
          [
            _c(
              "BTooltip",
              {
                staticClass: "add-button",
                attrs: { label: "Agregar otro pago", type: "is-success" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass:
                      "button add-otherPayment is-success is-rounded",
                    on: {
                      click: function($event) {
                        return _vm.$store.commit("payroll/addOtherPaymentRow")
                      }
                    }
                  },
                  [_c("BIcon", { attrs: { icon: "plus" } })],
                  1
                )
              ]
            )
          ],
          1
        )
      ]),
      _c(
        "BTable",
        {
          attrs: {
            data: _vm.otherPaymentsWithIndex,
            columns: _vm.columns,
            detailed: "",
            "has-detailed-visible": function(row) {
              return row.otherPaymentType === "004"
            }
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(props) {
                return [
                  _c(
                    "BTableColumn",
                    {
                      staticClass: "limit-300",
                      attrs: { field: "otherPaymentType", internal: "" }
                    },
                    [
                      _c(
                        "BField",
                        [
                          _c(
                            "BSelect",
                            {
                              staticClass: "is-fullwidth",
                              attrs: {
                                name: "otherPaymentType",
                                placeholder: "Selecciona el tipo",
                                value: props.row.otherPaymentType,
                                disabled: _vm.loading,
                                loading: _vm.loading,
                                required: ""
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onInput(
                                    props.row.id,
                                    "otherPaymentType",
                                    $event
                                  )
                                }
                              }
                            },
                            _vm._l(_vm.otherPaymentTypeCatalog, function(
                              option
                            ) {
                              return _c(
                                "option",
                                {
                                  key: option.value,
                                  domProps: { value: option.value }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(option.label) +
                                      "\n            "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "key", internal: "" } },
                    [
                      _c(
                        "BField",
                        [
                          _c("BInput", {
                            attrs: {
                              name: "key",
                              placeholder:
                                "Ingresa una clave de identificación",
                              value: props.row.key,
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.onInput(props.row.id, "key", $event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "concept", internal: "" } },
                    [
                      _c(
                        "BField",
                        [
                          _c("BInput", {
                            attrs: {
                              name: "concept",
                              placeholder: "Ingresa un concepto de pago",
                              value: props.row.concept,
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.onInput(
                                  props.row.id,
                                  "concept",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "amount", internal: "" } },
                    [
                      _c(
                        "BField",
                        [
                          _c("BInput", {
                            attrs: {
                              name: "amount",
                              placeholder: "Ingresa el monto ha pagar",
                              type: "number",
                              min: "0",
                              step: "0.01",
                              value: props.row.amount,
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.onInput(
                                  props.row.id,
                                  "amount",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    {
                      attrs: {
                        visible: props.row.otherPaymentType === "002",
                        field: "subsidyCaused",
                        internal: ""
                      }
                    },
                    [
                      _c(
                        "BField",
                        [
                          _c("BInput", {
                            attrs: {
                              name: "subsidyCaused",
                              placeholder: "0.00",
                              type: "number",
                              min: "0",
                              step: "0.01",
                              value: props.row.subsidyCaused,
                              required: ""
                            },
                            on: {
                              input: function($event) {
                                return _vm.onInput(
                                  props.row.id,
                                  "subsidyCaused",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    {
                      attrs: {
                        visible: props.row.otherPaymentType !== "002",
                        field: "subsidyCaused",
                        internal: ""
                      }
                    },
                    [_c("BField")],
                    1
                  ),
                  _c(
                    "BTableColumn",
                    { attrs: { field: "actions", internal: "" } },
                    [
                      _c("span", { staticClass: "actions" }, [
                        _c(
                          "a",
                          {
                            staticClass: "button is-danger",
                            on: {
                              click: function($event) {
                                return _vm.$store.commit(
                                  "payroll/deleteOtherPayment",
                                  props.row.id
                                )
                              }
                            }
                          },
                          [
                            _c("BIcon", {
                              attrs: { icon: "delete", "aria-hidden": "true" }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ]
              }
            },
            {
              key: "detail",
              fn: function(props) {
                return [
                  _c("div", { staticClass: "columns" }, [
                    _c(
                      "div",
                      { staticClass: "column is-3" },
                      [
                        _c(
                          "BField",
                          {
                            attrs: {
                              label: "Saldo a favor",
                              "label-for": "positiveBalance"
                            }
                          },
                          [
                            _c("BInput", {
                              attrs: {
                                name: "positiveBalance",
                                type: "number",
                                value: props.row.positiveBalance
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onInput(
                                    props.row.id,
                                    "positiveBalance",
                                    $event
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "column is-3" },
                      [
                        _c(
                          "BField",
                          {
                            attrs: {
                              label: "Año",
                              "label-for": "yearPositiveBalance"
                            }
                          },
                          [
                            _c("BInput", {
                              attrs: {
                                name: "key",
                                type: "number",
                                value: props.row.yearPositiveBalance
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onInput(
                                    props.row.id,
                                    "yearPositiveBalance",
                                    $event
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "column is-3" },
                      [
                        _c(
                          "BField",
                          {
                            attrs: {
                              label: "Remanente",
                              "label-for": "remainderPositiveBalance"
                            }
                          },
                          [
                            _c("BInput", {
                              attrs: {
                                name: "remainderPositiveBalance",
                                type: "number",
                                value: props.row.remainderPositiveBalance
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onInput(
                                    props.row.id,
                                    "remainderPositiveBalance",
                                    $event
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "empty" }, [
            _c("section", { staticClass: "section" }, [
              _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [
                  _c(
                    "p",
                    [
                      _c("BIcon", {
                        attrs: { icon: "emoticon-sad", size: "is-large" }
                      })
                    ],
                    1
                  ),
                  _c("p", [_vm._v("No has agregado otros pagos")])
                ]
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }